export default "__VITE_ASSET__D$jTtCtx__"